import { useEffect, useState } from 'react';
import { ws } from '@/ws';
import type { WsEvent, WsStatus, WsListener } from '@/ws';

export function useWsStatus(): WsStatus {
  const [status, setStatus] = useState<WsStatus>(ws.getStatus());
  useEffect(() => ws.onStatus(setStatus), []);
  return status;
}

export function useWsEvent(listener: WsListener): void {
  useEffect(() => ws.on(listener), [listener]);
}

export function useWsEventOfType(
  type: WsEvent['type'] | WsEvent['type'][],
  handler: (event: WsEvent) => void,
): void {
  useEffect(() => {
    const types = Array.isArray(type) ? type : [type];
    return ws.on((evt) => {
      if (types.includes(evt.type)) handler(evt);
    });
  }, [type, handler]);
}
